import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import Avatar from '@mui/material/Avatar';
import { Atleta } from '../../../services/atletaService';

import { useNavigate } from 'react-router-dom';
import { Tooltip, Switch, Snackbar, Alert } from '@mui/material';
import useToggleUsuarioAtivo from '../../../hooks/useToggleUsuarioAtivo';

interface AthletesTableProps {
  athletes: Atleta[];
  page: number;
  rowsPerPage: number;
  total: number;
  onPageChange: (page: number, rowsPerPage: number) => void;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
}

const AthletesTable: React.FC<AthletesTableProps> = ({
  athletes,
  page,
  rowsPerPage,
  total,
  onPageChange,
  onEdit,
  onDelete,
}) => {

  const navigate = useNavigate();
  const { toggle: toggleUsuario, isLoading } = useToggleUsuarioAtivo();

  const [optimisticByUserId, setOptimisticByUserId] = useState<Record<string, boolean>>({});
  const [snackbar, setSnackbar] = useState<{ open: boolean; message: string; severity: 'success' | 'error' }>({ open: false, message: '', severity: 'success' });
  
  const handleCloseSnackbar = () => setSnackbar((s) => ({ ...s, open: false }));

  const handleChangePage = (_: unknown, newPage: number) => {
    onPageChange(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    onPageChange(0, parseInt(e.target.value, 10));
  };

  const clickRow = (id: string) => {
    navigate('/userpage/' + id);
  }

  const goToPayment = (id: string) => {
    navigate('/admin/athlete/payments/' + id);
  };

  const getChecked = (userId?: string | null, fallback?: boolean | null | undefined) => {
    if (!userId) return Boolean(fallback);
    if (userId in optimisticByUserId) return optimisticByUserId[userId];
    return Boolean(fallback);
  };

  const onToggleAtivo = async (userId?: string | null, current?: boolean | null | undefined) => {
    if (!userId) return;
    const target = !Boolean(current);
    setOptimisticByUserId((prev) => ({ ...prev, [userId]: target }));
    try {
      await toggleUsuario(userId, target);
      setSnackbar({ open: true, message: target ? 'Usuário ativado.' : 'Usuário desativado.', severity: 'success' });
    } catch (e) {
      setOptimisticByUserId((prev) => {
        const copy = { ...prev };
        delete copy[userId];
        return copy;
      });
      setSnackbar({ open: true, message: 'Falha ao atualizar usuário.', severity: 'error' });
    }
  };

  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: '#6c757d' }}>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Imagem</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Nome</TableCell>
            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {athletes.map((a) => (
            <TableRow key={a.id} hover >
              <TableCell onClick={() => clickRow(a.id)} style={{ cursor: 'pointer' }}>
                <Avatar
                  src={a.usuario?.imagemUrl || '/assets/images/user.png'}
                  alt={a.usuario?.nome || 'avatar'}
                />
              </TableCell>
              <TableCell onClick={() => clickRow(a.id)} style={{ cursor: 'pointer' }}>
                {a.usuario?.nome || '-'}
                <div className='text-primary' style={{ fontSize: '0.8em' }}>
                  @{a.usuario?.username}
                </div>
              </TableCell>
              <TableCell>
                
                <Tooltip title="Editar">

                  <button
                    type="button"
                    className="btn btn-link text-primary me-2 p-0"
                    onClick={() => onEdit(a.id)}
                    >
                    <i className="bi bi-pencil-fill"></i>
                  </button>
                </Tooltip>
                {/* <button
                  type="button"
                  className="btn btn-link text-danger p-0"
                  onClick={() => onDelete(a.id)}
                >
                  Deletar
                </button> */}
                
                <Tooltip title="Pagamentos">
                  <button
                    type="button"
                    className="btn btn-link text-danger me-2 p-0"
                    onClick={() => goToPayment(a.id)}
                  >
                    <i className="bi bi-credit-card-fill"></i>
                  </button>
                </Tooltip>
                

                {a.usuario?.id && (
                  <Tooltip title={getChecked(a.usuario?.id, a.usuario?.ativo) ? 'Desativar usuário' : 'Ativar usuário'}>
                    <span>
                      <Switch
                        color="primary"
                        checked={getChecked(a.usuario?.id, a.usuario?.ativo)}
                        onChange={() => onToggleAtivo(a.usuario?.id, getChecked(a.usuario?.id, a.usuario?.ativo))}
                        disabled={isLoading(a.usuario?.id)}
                        inputProps={{ 'aria-label': 'Ativar ou desativar usuário' }}
                      />
                    </span>
                  </Tooltip>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={total}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25]}
      />
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      

    </TableContainer>
  );
};

export default AthletesTable;

